import React from 'react'
// hooks
import { useFormInitialValues } from 'hooks/risks'
// components
import Risk from '../Risk'
import RiskSkeleton from '../RiskSkeleton'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// types
import { IRisk } from 'types/graphql'

interface Props {
  form: string
  risk: IRisk
}

const RelatedRisk: React.FC<Props> = ({ form, risk }) => {
  const { isLoading } = React.useContext(RiskTemplateAPIContext)

  const { initialValues, isInitialValuesLoaded } = useFormInitialValues(isLoading, risk.fieldValueMap)

  if (isLoading || !isInitialValuesLoaded) {
    return <RiskSkeleton />
  }

  return <Risk form={form} initialValues={initialValues} isRelated />
}

export default RelatedRisk
